import { useEffect } from "react";
import { CustomCarousel } from "components";
import { AppDispatch, RootState } from "store";
import { useEffectDeviceAndOrientation } from "utils/hooks";

import BanerCard from "./BanerCard";
import "./Baners.scss";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchLargeBaners,
  fetchSmallBaners,
} from "store/baners/baners.slice";
import { Baner } from "store/baners/BanerType";

const Baners = () => {
  const [device, orientation] = useEffectDeviceAndOrientation();

  const { list, is_fetch } = useSelector(
    (store: RootState) => store.baners.small
  );
  const dispatch: (arg: any) => AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchSmallBaners());
  }, [dispatch]);

  return (
    <div className="Baners-Box">
      {/* TODO zakucan tekst */}
      <h2 className="Page-Title">Zašto kupovati kod nas?</h2>
      <CustomCarousel
        device_type={device}
        items_computer={3}
        items_tablet={2}
        items_mobile={1}
        slides_computer={1}
        slides_tablet={1}
        slides_mobile={1}
        partial_computer={0}
        partial_tablet={0}
        partial_mobile={0}
        show_dots={false}
        arrow_computer={true}
        arrow_tablet={true}
        arrow_mobile={false}
      >
        {list
          // .slice(0, 5)
          .map((baner: Baner, id: number) => {
            return (
              <BanerCard
                style={{ width: "100%", height: "100%" }}
                title={baner.baner_name}
                description={baner.baner_description}
                picture={baner.image}
                url={baner.url}
                seo_keywords={baner.seo_keywords}
                device={device}
                orientation={orientation}
                key={id}
              />
            );
          })}
      </CustomCarousel>
    </div>
  );
};
export default Baners;
